module.exports = __webpack_public_path__ + "img/system-message.c796ec09.svg";